export const bankName = "Tiroler Sparkasse"
export const IBAN = "AT62 2050 3033 0195 0808"
export const BIC = "SPIHAT22"
